import { useEffect } from "react";
import EventsApi from "../../../api/events";
import { useState } from "react";

export function usePatientFacing(eventId=null) {
  const [event, setEvent] = useState(null);
  const [error, setError] = useState(null);

  function fetchEvent(eventId, store=true) {
    setError(null);
    return EventsApi.getEventById(eventId)
      .then(event => {
        setEvent(event)
        if(store) {
          storeEventData(event);
        }
        return event;
      })
      .catch(err => {
        if (err.response?.status === 410) {
          setError({ type: 'expired', message: 'This link has expired - your procedure date has passed.' });
        } else {
          setError({ type: 'error', message: 'Failed to load event data.' });
        }
        throw err;
      });
  }

  // stores event data in session storage
  function storeEventData(eventData) {
    sessionStorage.setItem("eventData", JSON.stringify(
      eventData
    ));
    // Store facingType separately for analytics
    if (eventData?.facingType) {
      sessionStorage.setItem("facingType", eventData.facingType);
    }
  }

  // retrieves event data from session storage
  function getEventDataLocal() {
    return JSON.parse(sessionStorage.getItem("eventData"));
  }

  useEffect(() => {
    if(eventId) {
      fetchEvent(eventId).catch(() => {}); // Error handled in catch block
    }
  }, [])

  return {
    event,
    error,
    fetchEvent,
    getEventDataLocal,
  };
}